import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { getLatestTVShows } from '@/mocks/tvshows';
import { getPosterUrl } from '@/mocks/imageUrls';

export default function LatestTVShowsSection() {
  const shows = getLatestTVShows(8);

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新电视剧
            </h2>
            <p className="text-foreground-500 text-sm mt-2">热门剧集每日更新，追剧不等待</p>
          </div>
          <Link
            to="/category/tv"
            className="hidden sm:flex items-center gap-1 text-primary-400 hover:text-primary-300 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {shows.map((show) => (
            <MovieCard
              key={show.id}
              {...show}
              posterUrl={getPosterUrl(show.posterSeq)}
              episodes={show.episodes}
            />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/tv"
            className="inline-flex items-center gap-1 text-primary-400 hover:text-primary-300 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看全部电视剧
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}